import { useGet, useLoadable, useSet } from 'ccstate-react'
import { isOpen$ } from '../../../../frontend/components/UserMenu'
import { supabaseSession$ } from '../../../../frontend/authStates'
import { authClient } from '../../../../backendApi/authClient'

export default function UserMenu() {
  const session = useLoadable(supabaseSession$)
  const isOpen = useGet(isOpen$)
  const setIsOpen = useSet(isOpen$)

  if (session.state !== 'hasData') return null

  const user = session.data?.user

  if (!user) return null

  const handleSignOut = async () => {
    await authClient.signOut()
    setIsOpen(false)
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        <img
          className="h-8 w-8 rounded-full"
          src={user.user_metadata?.avatar_url || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.email || 'User')}&background=6366f1&color=fff`}
          alt="User avatar"
        />
        <span className="text-gray-700">{user.user_metadata?.name || user.email}</span>
        <svg
          className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 ring-1 ring-black ring-opacity-5">
          <div className="px-4 py-2 text-xs text-gray-500 border-b">
            Signed in as
          </div>
          <div className="px-4 py-2 text-sm font-medium text-gray-900 border-b">
            {user.email}
          </div>
          <button
            onClick={handleSignOut}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            Sign out
          </button>
        </div>
      )}

      {/* Overlay to close menu when clicking outside */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  )
}